import { useContext } from "react";
import Context from "./Context";

export default function useLogout() {
  const { logout } = useContext(Context);
  return logout;
}
